import axios from 'axios'

const ENDPOINT = 'menuitem'

export default {
  delete: async (centro_id, id) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (centro_id, id) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`
    return await axios.get(url)
  },

  getAll: async centro_id => {
    const url = `${centro_id}/${ENDPOINT}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (centro_id, data) => {
    const url = `${centro_id}/${ENDPOINT}/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (centro_id, id, data) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`
    return await axios.put(url, data)
  },

  getQMenuItems: async (centro_id, parent) => {
    let url = `${centro_id}/${ENDPOINT}/`
    if (parent) {
      const eparent = encodeURIComponent(parent)
      url += `?parent=${eparent}`
    }
    const response = await axios.get(url)

    return response.data
  },

  getQMenuItemsFull: async centro_id => {
    const response = await axios.get(`${centro_id}/${ENDPOINT}/full`)

    return response.data
  },

  copyFromParent: async centro_id => {
    const url = `${centro_id}/${ENDPOINT}/copy_from_parent/`
    const response = await axios.get(url)

    return response.data
  },
}
